
import {of as observableOf,  Observable } from 'rxjs';

import {catchError} from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { MarketoList } from '@routes/events/event-detail/invitation-list/invitation-list-import-marketo/invitation-list-import-marketo.component';
import { IContactsByMarketoList, IMarketoListsForDropdown } from '@shared/services/api/legacy/marketolists-service/marketolist-model';
import { ErrorResponse, SuccessResponse } from '@shared/services/api/legacy/response';

@Injectable()
export class MarketoListsService {
    constructor(private http: HttpClient) { }

    private static get URL(): string { return `${environment.api.baseUrl}${environment.api.prefix}${MarketoListsService.ENDPOINT}`; }
    private static readonly ENDPOINT = '/marketolists';

    public getMarketoListsForDropdown(): Observable<SuccessResponse<IMarketoListsForDropdown> | ErrorResponse> {
        return this.http
            .get<SuccessResponse<IMarketoListsForDropdown>>(MarketoListsService.URL + '/dropdown').pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public getContactsByHubspotList(listId: number): Observable<SuccessResponse<IContactsByMarketoList> | ErrorResponse> {
        return this.http
            .get<SuccessResponse<IContactsByMarketoList>>(MarketoListsService.URL + '/'+ listId + '/contacts').pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }
}
